// Aligned with the backend domain enum (InviteDesk.Domain.Enums.SpeakersPageDisplayType) and the new
// events-app, which are the source of truth for the shared event-level speakers page. List = 1 renders
// vertical rows; Tile = 2 renders a grid of cards.
export enum SpeakersPageDisplayType {
    Undefined = 0,
    List = 1,
    Tile = 2
}
